/** @jsxImportSource @emotion/react */

import { Empty } from "antd";
import PromotionBanner from "assets/desktop/images/promotion-banner.jpeg";
import Container from "components/common/Container";
import HelmetCustom from "components/common/HelmetCustom";
import MDrawer from "components/mobile/MDrawer";
import {
  PROMOTIONS_ALL,
  PROMOTIONS_CASINO,
  PROMOTIONS_CASINO_GAME,
  PROMOTIONS_DEPOSIT,
  PROMOTIONS_EXPLODING,
  PROMOTIONS_FISH,
  PROMOTIONS_GAME_CHICKEN,
  PROMOTIONS_HOT,
  PROMOTIONS_SPORT,
} from "dummys/promotion";
import { DeviceScreenWidth } from "enums/device";
import useWindowSize from "hooks/useWindowSize";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isMobile } from "router";
import { getPromotionList } from "store/retrive/retrive.thunk";
import { AppDispatch } from "types";
import { Promotion } from "types/retrive";

import MPromotionDetail from "../PromotionPage/MPromotionDetail";
import PromotionCard from "../PromotionPage/PromotionCard";
import PromotionCategory from "../PromotionPage/PromotionCategory";
import { PromotionDevelopPageStyle } from "./index.style";

const PromotionDevelopPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  // const { isLoading, data } = useSelector(selectPromotionList);
  const { width } = useWindowSize();
  const navigate = useNavigate();

  const [isOpenDraw, setIsOpenDraw] = useState<boolean>(true);
  const [promotionSelected, setPromotionSelected] = useState<Promotion | null>(
    null,
  );
  const [promotionType, setPromotionType] = useState<string>("1");

  const handleCloseDraw = () => {
    setIsOpenDraw(false);
    navigate(-1);
    setPromotionSelected(null);
  };

  const handleShowDrawDetail = (promotion: Promotion) => {
    if (!promotion.link) {
      setPromotionSelected(promotion);
    }
  };

  const handleBack = () => {
    setPromotionSelected(null);
  };

  const handleFilter = (value: string) => {
    setPromotionType(value);
  };

  const promotionList = useMemo(() => {
    switch (promotionType) {
      case "1":
        return PROMOTIONS_HOT;
      case "2":
        return PROMOTIONS_ALL;
      case "3":
        return PROMOTIONS_DEPOSIT;
      case "4":
        return PROMOTIONS_EXPLODING;
      case "5":
        return PROMOTIONS_FISH;
      case "6":
        return PROMOTIONS_CASINO;
      case "7":
        return PROMOTIONS_CASINO_GAME;
      case "8":
        return PROMOTIONS_SPORT;
      case "9":
        return PROMOTIONS_GAME_CHICKEN;
    }
    return [];
  }, [promotionType]);

  useEffect(() => {
    dispatch(getPromotionList());
  }, []);

  return (
    <div css={PromotionDevelopPageStyle.self}>
      {!isMobile && (
        <div css={PromotionDevelopPageStyle.banner}>
          <img src={PromotionBanner} alt="" />
        </div>
      )}
      <div css={PromotionDevelopPageStyle.wrapper}>
        <HelmetCustom title="Promotion" />
        {/* {isLoading ? (
          <Loading height={500} center />
        ) : ( */}
        <Container>
          {isMobile ? (
            // mobile
            <MDrawer
              title="Khu vực ưu đãi"
              isOpen={isOpenDraw}
              onClose={handleCloseDraw}
              isBack={!!promotionSelected}
              onBack={handleBack}
            >
              {promotionSelected ? (
                <MPromotionDetail
                  isSubcribe={promotionSelected.button}
                  content={promotionSelected.content}
                />
              ) : (
                <>
                  <div css={PromotionDevelopPageStyle.categoryWrapper}>
                    <PromotionCategory
                      value={promotionType}
                      onValueChange={handleFilter}
                    />
                  </div>
                  {Array.isArray(promotionList) && promotionList.length ? (
                    <div css={PromotionDevelopPageStyle.listPromos}>
                      {promotionList.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleShowDrawDetail(item)}
                        >
                          <PromotionCard
                            name={item.bonus}
                            image={
                              width > DeviceScreenWidth.MOBILE
                                ? item.mobile
                                : item.web
                            }
                            wager={item.wager}
                            content={item.content}
                            isSubcribe={item.button}
                            link={item.link}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div css={PromotionDevelopPageStyle.empty}>
                      <Empty />
                    </div>
                  )}
                </>
              )}
            </MDrawer>
          ) : (
            // desktop
            <>
              <div css={PromotionDevelopPageStyle.categoryWrapper}>
                <PromotionCategory
                  value={promotionType}
                  onValueChange={handleFilter}
                />
              </div>
              {Array.isArray(promotionList) && promotionList.length ? (
                <div css={PromotionDevelopPageStyle.listPromos}>
                  {promotionList.map((item, index) => (
                    <PromotionCard
                      key={index}
                      name={item.bonus}
                      image={
                        width > DeviceScreenWidth.MOBILE
                          ? item.mobile
                          : item.web
                      }
                      wager={item.wager}
                      content={item.content}
                      isSubcribe={item.button}
                      link={item.link}
                    />
                  ))}
                </div>
              ) : (
                <div css={PromotionDevelopPageStyle.empty}>
                  <Empty />
                </div>
              )}
            </>
          )}
        </Container>
        {/* )} */}
      </div>
    </div>
  );
};

export default PromotionDevelopPage;
